/*
 * @Author: ningbo.kang
 * @Date: 2020-03-30 16:17:50
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2022-09-26 11:13:31
 * @Description: 描述
 */
const formComponents = [
  'cascader',
  'checkbox',
  'date',
  'dateRange',
  'fileupload',
  'hidden',
  'input',
  'number',
  'radio',
  'rate',
  'select',
  'slider',
  'switch',
  'table',
  'text',
  'time',
  'treeSelect',
  'textarea',
  'dialog',
];

export const isFormComponent = name => formComponents.includes(name);
/**
 * 设置表单组件模式规则
 * @param {*} rules
 * @param {*} ruleId
 * @param {*} rule
 */
export function addSchemaRule(rules, ruleId, rule) {
  let existRule = rules.find(item => item.id === ruleId);
  if (existRule) {
    existRule = {
      id: ruleId,
      ...rule,
    };
  } else {
    rules.push({
      id: ruleId,
      ...rule,
    });
  }
}
/**
 * 移除表单组件模式规则
 * @param {*} rules
 * @param {*} ruleId
 */
export function removeSchemaRule(rules, ruleId) {
  const index = rules.findIndex(item => item.id === ruleId);
  rules.splice(index, 1);
}

export default {};
